import { type FC, useEffect, useState, useRef } from 'react';

interface TurnNarrativeProps {
  text: string;           // Full text to display
  streaming?: boolean;    // Is Claude still streaming?
}

// ---------------------------------------------------------------------------
// Typewriter effect for Claude streaming narrative
// ---------------------------------------------------------------------------

export const TurnNarrative: FC<TurnNarrativeProps> = ({ text, streaming }) => {
  const [displayed, setDisplayed] = useState('');
  const prevTextRef = useRef('');

  useEffect(() => {
    const prev = prevTextRef.current;
    // If new text is extension of prev (streaming), show everything
    if (text.startsWith(prev)) {
      setDisplayed(text);
      prevTextRef.current = text;
    } else {
      // New turn — reset
      setDisplayed('');
      prevTextRef.current = '';
      let i = 0;
      const id = setInterval(() => {
        i++;
        setDisplayed(text.slice(0, i));
        prevTextRef.current = text.slice(0, i);
        if (i >= text.length) clearInterval(id);
      }, 8);
      return () => clearInterval(id);
    }
  }, [text]);

  if (!text && !streaming) return null;

  // Split into paragraphs for better readability
  const paragraphs = displayed.split(/\n\n+/).filter(Boolean);

  return (
    <div className="text-[12px] text-slate-300 leading-relaxed space-y-2.5">
      {paragraphs.map((para, i) => (
        <p key={i} className="leading-relaxed">{para}</p>
      ))}
      {streaming && (
        <span className="inline-block w-1.5 h-3.5 bg-amber-400 animate-pulse ml-0.5 align-text-bottom" />
      )}
      {!streaming && !displayed && (
        <p className="text-slate-600 italic text-[11px]">Awaiting analysis...</p>
      )}
    </div>
  );
};
